
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Punetoshirdiswiftdzire() {



    const cardData =
    {
        keyword: ' Pune to Shirdi Swift Dzire Cab',
        heading: 'Prince Cabs: Pune to Shirdi Swift Dzire Cab',
        headingDescription: 'Prince Cabs provides reliable Pune to Shirdi Swift Dzire Cab services, ideal for Sai Baba Darshan, family trips, and pilgrimage tours. Our well-maintained Swift Dzire cars are fuel-efficient, comfortable, and budget-friendly, ensuring a smooth ride along the Pune–Ahmednagar–Shirdi route. With professional chauffeurs, on-time pickups, and flexible travel options, we make your spiritual journey convenient and stress-free. Choose Prince Cabs’ trusted Swift Dzire cab service from Pune to Shirdi for affordability, safety, and a hassle-free travel experience.',

        top: 'Top Places to Visit in Shirdi with Prince Cabs',

 "topPlaces": [
  {
    "title": "Sai Baba Samadhi Mandir",
    "description": "The Sai Baba Samadhi Mandir is the spiritual heart of Shirdi, where the sacred remains of Shri Sai Baba are enshrined. Built with white marble, it attracts millions of devotees from across the world. Daily aartis such as Kakad Aarti and Shej Aarti fill the temple with devotion and energy. The idol of Sai Baba, adorned with gold and jewels, radiates peace. Long queues of devotees reflect the faith and love for Baba. It is the most important place to visit in Shirdi."
  },
  {
    "title": "Dwarkamai Masjid",
    "description": "Dwarkamai is the mosque where Sai Baba lived and blessed his devotees for most of his life. The sacred dhuni (fire) lit by Baba still burns here, and its Udi (sacred ash) is considered miraculous. Inside, one can see Baba’s palkhi, sacred stones, and photographs. The mosque represents Sai Baba’s teachings of unity and compassion. Devotees experience deep spiritual calm here. Dwarkamai is the symbol of Baba’s divine presence in Shirdi."
  },
  {
    "title": "Chavadi",
    "description": "Chavadi is a small but significant place where Sai Baba used to sleep every alternate night. The weekly palkhi procession still recreates the tradition of Baba’s journey to Chavadi. Inside, visitors can see Baba’s wooden chair, bed, and portraits. The place is filled with devotion and historic charm. Its proximity to the Samadhi Mandir makes it easy to visit. Chavadi is a powerful reminder of Baba’s humility and spiritual discipline."
  },
  {
    "title": "Khandoba Temple",
    "description": "Khandoba Temple holds historic importance as it was here that Sai Baba was first welcomed to Shirdi. The priest Mhalsapati greeted him with the words 'Aao Sai,' giving him the name by which the world knows him today. The temple is dedicated to Lord Khandoba, a form of Lord Shiva. Though simple in design, it carries immense spiritual value. Pilgrims honor it as the beginning of Baba’s divine journey in Shirdi. It combines faith, history, and devotion."
  },
  {
    "title": "Sai Heritage Village",
    "description": "Sai Heritage Village is a theme park that beautifully recreates the life and miracles of Sai Baba through statues and exhibits. It educates visitors about Baba’s teachings in an interactive way. The landscaped park also features gardens, children’s play areas, and a small eatery. Families enjoy combining devotion with relaxation here. The village hosts cultural events during festive seasons. It blends spirituality, history, and entertainment seamlessly."
  },
  {
    "title": "Gurusthan",
    "description": "Gurusthan is the place where Sai Baba was first seen meditating under a neem tree. Devotees believe the neem leaves here have healing properties. The shrine houses a marble idol of Sai Baba, a shivling, and photographs of saints. Pilgrims light incense sticks here for blessings and peace. The spot is considered the spiritual birthplace of Sai Baba’s journey in Shirdi. Gurusthan is a must-visit for every devotee seeking Baba’s divine grace."
  },
  {
    "title": "Lendi Baug",
    "description": "Lendi Baug is a serene garden where Sai Baba used to water plants and meditate daily. The sacred Nanda Deep, a lamp lit by Baba, continues to burn here. The well-maintained garden has pathways, greenery, and flowers, offering visitors a calm retreat. Devotees feel spiritually refreshed in its tranquil surroundings. It is a beautiful reflection of Baba’s simple lifestyle and love for nature. Lendi Baug is both a spiritual and natural attraction in Shirdi."
  },
  {
    "title": "Wet N Joy Water Park",
    "description": "Wet N Joy is a popular amusement and water park near Shirdi, offering a refreshing break for families and children. It features thrilling rides, wave pools, rain dance, and fun slides. Tourists often combine temple darshan with a leisure day here. The park is clean, well-maintained, and family-friendly. It provides an entertaining balance to the spiritual journey. Wet N Joy is especially popular among young visitors."
  },
  {
    "title": "Upasani Maharaj Ashram",
    "description": "Located in Sakori near Shirdi, the Upasani Maharaj Ashram is dedicated to Sai Baba’s close disciple, Upasani Maharaj. The ashram includes meditation halls, temples, and accommodation for devotees. Visitors learn about Maharaj’s teachings and his role in spreading Sai Baba’s message. Its peaceful environment attracts spiritual seekers. The ashram expands the spiritual circle beyond Shirdi. It is an enlightening stop for pilgrims."
  },
  {
    "title": "Shani Shingnapur",
    "description": "About 70 km from Shirdi, Shani Shingnapur is a unique village temple dedicated to Lord Shani. The deity is housed in the open without a roof, symbolizing trust and faith. Remarkably, the houses in the village traditionally have no doors, showing belief in Lord Shani’s protection. Saturdays attract huge crowds of devotees. Pilgrims often combine Shani Shingnapur with their Shirdi trip. It is a powerful destination for faith and devotion."
  }
],

"services": [
    {
        "name": "Pune Airport to Shirdi Sedan Taxi Cab",
        "description": "Book a reliable sedan taxi cab from Pune Airport to Shirdi for a safe and smooth pilgrimage journey. Our well-maintained Dzire and Etios cabs ensure comfort and punctual service with experienced drivers and flexible travel schedules."
    },
    {
        "name": "Pune to Shirdi Dzire Taxi Fare",
        "description": "Get the best fare for Pune to Shirdi Dzire taxi rides with affordable rates and transparent pricing. Enjoy a comfortable and economical ride with courteous drivers and well-kept vehicles, perfect for individuals and small families."
    },
    {
        "name": "Pune to Shirdi Cab Package",
        "description": "Choose from our flexible Pune to Shirdi cab packages that include round trips, single-day return, and overnight stays. Packages cover fuel, driver charges, and offer multiple vehicle options including Dzire, Etios, and Innova."
    },
    {
        "name": "Pune to Shirdi Swift Package Cab",
        "description": "Travel from Pune to Shirdi in a Swift Dzire with our all-inclusive package cab service. This deal includes driver allowance, tolls, and return fare – ideal for a stress-free pilgrimage experience with your family."
    },
    {
        "name": "Pune to Shani Shingnapur Cab",
        "description": "Book a cab from Pune to Shani Shingnapur with reliable service and professional drivers. Choose from a range of vehicles including sedans and hatchbacks for a smooth religious journey at budget-friendly prices."
    },
    {
        "name": "Pune to Shani Shingnapur Swift Package Cab",
        "description": "Take a comfortable trip to Shani Shingnapur in a Swift Dzire with our special package cab service from Pune. This package includes driver, toll, and return fare with no hidden charges – ideal for temple visits and same-day return."
    },
    {
        "name": "Pune to Shirdi Dzire Cab Booking",
        "description": "Easily book a Dzire cab from Pune to Shirdi for a reliable and pocket-friendly travel experience. Enjoy clean cars, timely pickup, and flexible booking options suitable for personal or group travel."
    },
    {
        "name": "Pune to Shirdi Dzire Family Cab",
        "description": "Travel with your family from Pune to Shirdi in a spacious and comfortable Swift Dzire. Our family cab service ensures a relaxed and private trip with enough boot space for luggage and on-time arrivals."
    },
    {
        "name": "Pune to Shirdi Dzire Round Trip Taxi",
        "description": "Book a round-trip Dzire taxi from Pune to Shirdi with competitive pricing and no extra charges. Perfect for one-day temple visits or overnight stays, with professional drivers and flexible return timing."
    },
    {
        "name": "Pune to Shirdi Dzire Affordable Taxi",
        "description": "Looking for a budget ride to Shirdi? Our affordable Dzire taxi service from Pune offers low-cost fares, clean cars, and smooth rides with skilled drivers, perfect for pilgrims and tourists alike."
    }
],
"tableData": [
    ["Pune Airport to Shirdi Sedan Taxi Cab", "Pune to Shirdi Dzire Taxi Fare"],
    ["Pune to Shirdi Cab Package", "Pune to Shirdi Swift Package Cab"],
    ["Pune to Shani Shingnapur Cab", "Pune to Shani Shingnapur Swift Package Cab"],
    ["Pune to Shirdi Dzire Cab Booking", "Pune to Shirdi Dzire Family Cab"],
    ["Pune to Shirdi Dzire Round Trip Taxi", "Pune to Shirdi Dzire Affordable Taxi"]
],


"whychoose": [
    {
        "WhyChooseheading": "Affordable Pune to Shirdi Swift Dzire Cab Service",
        "WhyChoosedescription": "Prince Cabs offers comfortable and budget-friendly Swift Dzire cab service from Pune to Shirdi, perfect for solo travelers, couples, or small families visiting the sacred Sai Baba temple. The Swift Dzire is an economical sedan choice that ensures a smooth and pleasant ride across the 4 to 5-hour journey from Pune to Shirdi."
    },
    {
        "WhyChooseheading": "Fuel-Efficient and Comfortable Travel Option",
        "WhyChoosedescription": "Our Swift Dzire sedans offer spacious seating for up to 4 passengers with sufficient luggage space. With excellent fuel efficiency, clean interiors, working AC, and cushioned seating, the Dzire is perfect for those looking for a reliable yet economical option for religious travel or weekend getaways."
    },
    {
        "WhyChooseheading": "Experienced Drivers Familiar with Shirdi Route",
        "WhyChoosedescription": "Prince Cabs employs professional and courteous drivers who are well-versed with the Pune–Shirdi highway route. They ensure safe, timely, and comfortable travel with proper rest stops, knowledge of temple timings, and options for detours like Shani Shingnapur if requested."
    },
    {
        "WhyChooseheading": "Flexible Travel Packages: One-Way, Round Trip & Custom Plans",
        "WhyChoosedescription": "Whether you need a one-way drop to Shirdi, a same-day return, or a multi-day spiritual tour, we offer flexible rental packages to suit your schedule. Pick-up is available from anywhere in Pune including Hinjewadi, Katraj, Kothrud, Wakad, or even Pune Airport — and drop-off at your preferred spot in Shirdi."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "Our Pune to Shirdi Swift Dzire cab fares are clearly explained with no hidden costs. Choose from per km rates or all-inclusive fixed packages that cover fuel, driver allowance, tolls, and parking. Pay securely via UPI, credit/debit card, bank transfer, or cash."
    },
    {
        "WhyChooseheading": "Sanitized & Well-Maintained Swift Dzire Fleet",
        "WhyChoosedescription": "All our Dzire cabs are cleaned and sanitized before and after each trip, ensuring a hygienic travel environment. Each vehicle undergoes regular maintenance checks, and comes equipped with seat belts, AC, and essential safety features for your peace of mind."
    },
    {
        "WhyChooseheading": "24/7 Booking & Travel Assistance",
        "WhyChoosedescription": "Our support team is available 24/7 to help you book your Pune to Shirdi Swift Dzire cab easily via phone, WhatsApp, or online. We’re also available during your journey to handle any changes, delays, or special requests to make your spiritual trip smooth and worry-free."
    }
]

























    }

const faqData = [
    {
        question: 'Does Prince Cabs offer Swift Dzire cab service from Pune to Shirdi?',
        answer: 'Yes, Prince Cabs provides reliable and affordable Swift Dzire cabs from Pune to Shirdi for one-way, round-trip, and same-day return travel.',
    },
    {
        question: 'What is the fare for a Swift Dzire cab from Pune to Shirdi?',
        answer: 'Fares for Swift Dzire cabs from Pune to Shirdi start at ₹3,800 for a one-way trip. Pricing may vary based on the pickup point and travel time.',
    },
    {
        question: 'How long is the travel time from Pune to Shirdi by Swift Dzire?',
        answer: 'The journey typically takes around 4.5 to 5.5 hours depending on traffic and road conditions, with smooth highway routes along the way.',
    },
    {
        question: 'Is Swift Dzire comfortable for long-distance travel like Pune to Shirdi?',
        answer: 'Yes, Swift Dzire is a comfortable and fuel-efficient sedan ideal for small families or solo travelers on religious and leisure trips.',
    },
    {
        question: 'Can I book a round trip Swift Dzire cab from Pune to Shirdi?',
        answer: 'Absolutely! Prince Cabs offers both one-way and round-trip packages to Shirdi with the flexibility of same-day or next-day return options.',
    },
    {
        question: 'Are the Swift Dzire cabs sanitized and well-maintained?',
        answer: 'Yes, all Swift Dzire vehicles are regularly cleaned, sanitized, and inspected to ensure a safe and pleasant journey for our customers.',
    },
    {
        question: 'How do I book a Swift Dzire cab from Pune to Shirdi?',
        answer: 'You can book easily through our website or call our customer care. Just provide your travel date and time, and we’ll schedule your ride.',
    },
];

const testimonials = [
    {
        name: "Mr. Anil Shinde",
        position: "Devotee",
        text: "Booked a Swift Dzire from Pune to Shirdi with Prince Cabs. The cab was clean, driver was on time, and the journey was peaceful. Great experience!",
        image: "/img/testimonial/testimonial-thumb-dzire-shirdi-1.png",
    },
    {
        name: "Ms. Pooja Kharat",
        position: "Solo Traveler",
        text: "Travelled solo from Pune to Shirdi in a Swift Dzire cab. The ride was smooth, affordable, and punctual. Prince Cabs delivered exactly as promised.",
        image: "/img/testimonial/testimonial-thumb-dzire-shirdi-2.png",
    },
];






























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Pune to Shirdi Swift Dzire Cab",
  "description": "Swift Dzire taxi service from Pune to Shirdi offering affordable cab packages, round trips, family cabs, and convenient airport to Shirdi sedan taxi.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Prince Cabs",
    "telephone": "+91-XXXXXXXXXX",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Pune",
      "addressRegion": "Maharashtra",
      "addressCountry": "IN"
    }
  },
  "serviceType": [
    "Pune Airport to Shirdi Sedan Taxi Cab",
    "Pune to Shirdi Dzire Taxi Fare",
    "Pune to Shirdi Cab Package",
    "Pune to Shirdi Swift Package Cab",
    "Pune to Shani Shingnapur Cab",
    "Pune to Shani Shingnapur Swift Package Cab",
    "Pune to Shirdi Dzire Cab Booking",
    "Pune to Shirdi Dzire Family Cab",
    "Pune to Shirdi Dzire Round Trip Taxi",
    "Pune to Shirdi Dzire Affordable Taxi"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  }
};





    return (
        <div>

<Helmet>
  <title>Pune to Shirdi Swift Dzire Cab | Affordable & Reliable Taxi Service</title>
  <meta
    name="description"
    content="Swift Dzire taxi service from Pune to Shirdi offering affordable cab packages, round trips, family cabs, and convenient airport to Shirdi sedan taxi."
  />
  <meta
    name="keywords"
    content="Pune Airport to Shirdi Sedan Taxi Cab, Pune to Shirdi Dzire Taxi Fare, Pune to Shirdi Cab Package, Pune to Shirdi Swift Package Cab, Pune to Shani Shingnapur Cab, Pune to Shani Shingnapur Swift Package Cab, Pune to Shirdi Dzire Cab Booking, Pune to Shirdi Dzire Family Cab, Pune to Shirdi Dzire Round Trip Taxi, Pune to Shirdi Dzire Affordable Taxi"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/45.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoshirdiswiftdzire ;